
import React from 'react';

interface SelectOption {
  value: string | number;
  label: string;
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: SelectOption[];
  containerClassName?: string;
  placeholderOption?: string; // e.g., "Selecione uma opção"
}

export const Select: React.FC<SelectProps> = ({
  label,
  id,
  error,
  options,
  className = '',
  containerClassName = '',
  placeholderOption,
  ...props
}) => {
  const baseSelectStyle = "block w-full pl-3 pr-10 py-2 bg-gray-100 dark:bg-dark-secondary border border-gray-300 dark:border-dark-tertiary rounded-md shadow-sm focus:outline-none focus:ring-brand-teal focus:border-brand-teal sm:text-sm text-gray-900 dark:text-dark-text-primary";
  const errorSelectStyle = "border-red-500 focus:ring-red-500 focus:border-red-500";

  return (
    <div className={`mb-4 ${containerClassName}`}>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-700 dark:text-dark-text-secondary mb-1">
          {label}
        </label>
      )}
      <select
        id={id}
        className={`${baseSelectStyle} ${error ? errorSelectStyle : ''} ${className}`}
        {...props}
      >
        {placeholderOption && <option value="">{placeholderOption}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
};